<template>
  <div style="margin: 8px 0">
    <img :class="style.icon" v-for="(icon, index) in iconList" :key="index" :src="iconMapping[icon]" alt="" />
    <span v-if="displayNumber > 5">× {{ displayNumber }}</span>
  </div>
</template>

<script>
import { iconMapping } from 'javascript/Constants'
import style from './scss/_slider.scss'

export default {
  props: {
    iconList: Array,
    displayNumber: Number
  },
  computed: {
    style: () => style,
    iconMapping: () => iconMapping
  }
}
</script>
